import React, { lazy } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, formattedPrice,
  getBranches,
  getEmployes,
  getStatus,
  getTypes,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import logo from "../../assets/images/no-image.png";
import withPermissions from "../../components/WithPermissions";
import Select from "react-select";
import { openCustomerDetailModel, closeCustomerDetailModel, openVehicleDetailModel, closeVehicleDetailModel } from "../../actions";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
import CustomerDetailModal from "../../components/Modals/CustomerDetailModal";
import VehicleDetailModal from "../../components/Modals/VehicleDetailModal";
import ServiceImageGallery from "../../components/ServiceImageGallery";
import ServiceSummarySelect from "../../components/ServiceSummarySelect";
import ServiceSummaryDescription from "../../components/ServiceSummaryDescription";
import ServiceLaborCommission from "../../components/ServiceLaborCommission";
import { lineLaborExtraCost } from "../../helpers/LaborCommission";
import ServiceImagePicker from "../../components/ServiceImagePicker";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import QuickSupplierModal from "../../components/Modals/QuickSupplierModal";
import "../../components/ModernDropdown.css";
import "./ServiceDetail.css";

const createProcessLineKey = () => {
  if (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : ((random & 0x3) | 0x8);
    return value.toString(16);
  });
};

const createEmptyProcess = () => ({
  line_key: createProcessLineKey(),
  process: "",
  supplier_id: null,
  supplier_name: null,
  price: "",
  cost: "",
  kdv: 0,
  discount: "",
  unit: "C62",
  quantity: 1,
});

export class ServiceDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      service: [],
      employes: [],
      branches: [],
      types: [],
      status: [],
      images: [],
      vehicleImages: [],
      showVehicleImageModal: false,
      selectedVehicleImage: null,
      brands: [],
      models: [],
      cities: [],
      districts: [],
      processNames: [],
      suppliers: [],
      selectedBrand: '',
      selectedModel: '',
      tevkifat: [],
      isMobile: false,
      selectedTevkifat: '',
      net_total: '',
      showTevkifatDelButton: false,
      showWithholdingModal: false,
      showQuickSupplierModal: false,
      quickSupplierProcessIndex: null,
      showDropdown: null,
      filteredProcessNames: [],
      formData: {
        operationData: {
          id: '',
          assigned_employee_id: '',
          operation_type_id: '',
          description: '',
          price: '',
          vehicle_id: '',
          branch_id: '',
          review_count: '',
          brand: '',
          model: '',
          customer_id: '',
          customer_name: '',
          customer_surname: '',
          plate: '',
          gen: '',
          km: '',
          year: '',
          invoice_file: '',
          invoice_file_show: '',
          invoice_url: '',
          invoice_storage_type: 'local',
          withholding: '',
          withholding_amount: '',
          service_images: [],
        },
        operationStatus: {
          statu_id: '',
          customer_id: '',
          status_details: ''
        },
        vehicleData: {
          brand: '',
          branch_id: '',
          model: '',
          plate: '',
          year: '',
          km: '',
          chassis_no: '',
          engine_no: '',
          package_name: '',
          engine_size: '',
          key_no: '',
          details: '',
          vehicleImages: [],
          maintenance_date: '',
          next_maintenance_date: '',
          inspection_date: '',
          next_inspection_date: '',
          gear_type: '',
          gen: '',
        },
        customerData: {
          id: '',
          p_id: '',
          name: '',
          surname: '',
          phone: '',
          address: '',
          email: '',
          tax_district: '',
          tax_no: '',
          title: '',
          city_id: '',
          district_id: '',
          save_parasut: false,
          is_supplier: '',
          urn: '',
          invoice_type: 'EARSIV'
        },
      },
      partData: {
        year: "",
        gen: "",
        car_type: ""
      },
      created_at: '',
      processes: [createEmptyProcess()],
      parts: [{ name: "", part_type: "", year: "", gen: "", car_type: "", count: 4 }],
      partsResults: null,
      isLoad: true,
      statusLoading: false,
      processLoading: false,
      suppliersLoading: false,
      operationLoading: false,
      customerLoading: false,
      vehicleLoading: false,
      isStatusComplete: false,
      tevLoading: false,
      tevDelLoading: false,
      isEditingKm: false,
      isEditingKmLoading: false,
      kmValue: '',
      activeDetailSection: 'overview',
      showStatusModal: false,
      statusModalSnapshot: null,
      setKdv: false,
      isDragActive: false,
      serviceImagePreviews: [],
      showServiceImageUpload: false,
      serviceImagesLoading: false,
      serviceImagesError: '',
    };
    this.serviceImagesInputRef = React.createRef();
  }

  async componentDidMount() {
    try {
      const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);
      this.setState({ isMobile });
      this.getBrands();
      this.getCities();
      this.tevkifat();
      this.getProcessName();
      await this.getServiceInfo();
      const [branches, employes, types, status, suppliers] = await Promise.all([
        getBranches(),
        getEmployes(),
        getTypes(),
        getStatus(),
        this.getProcessSuppliers(),
      ]);
      this.setState({ branches, employes, types, status, suppliers }, () => {
        this.setState({ isLoad: false });
      });
      // Dropdown dışına tıklandığında kapatmak için event listener
      document.addEventListener('mousedown', this.handleClickOutside);
    } catch (error) {
      this.setState({ isLoad: false });
      console.error("Error fetching initial data:", error);
    }
  }

  componentWillUnmount() {
    this.state.serviceImagePreviews.forEach(preview => URL.revokeObjectURL(preview.url));
    // Event listener'ı temizle
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    // Dropdown dışına tıklandığında kapat
    const dropdownElements = document.querySelectorAll('.modern-dropdown-wrapper');
    let clickedInside = false;

    dropdownElements.forEach(element => {
      if (element.contains(event.target)) {
        clickedInside = true;
      }
    });

    if (!clickedInside && this.state.showDropdown !== null) {
      this.setState({ showDropdown: null });
    }
  };
  getProcessSuppliers = async () => {
    this.setState({ suppliersLoading: true });

    try {
      const response = await apiCall('business/customer/supplier/all?size=10000', 'get', null);
      return Array.isArray(response?.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      return [];
    } finally {
      this.setState({ suppliersLoading: false });
    }
  };
  getSupplierLabel = (supplier) => {
    if (!supplier) return '';

    return supplier.title
      || [supplier.name, supplier.surname].filter(Boolean).join(' ')
      || supplier.email
      || `Tedarikçi #${supplier.id}`;
  };
  normalizeProcesses = (processes) => {
    if (!Array.isArray(processes) || processes.length === 0) {
      return [createEmptyProcess()];
    }

    return processes.map((process) => ({
      ...createEmptyProcess(),
      ...process,
      line_key: process.line_key || createProcessLineKey(),
      supplier_id: process.supplier_id ? Number(process.supplier_id) : null,
      supplier_name: process.supplier_name || null,
    }));
  };
  getCities = async () => {

    const citiesFromStorage = localStorage.getItem('cities');

    if (citiesFromStorage) {
      this.setState({ cities: JSON.parse(citiesFromStorage) });
    } else {
      const response = await apiCall('get-cities', 'get', null);
      this.setState({ cities: response });

      localStorage.setItem('cities', JSON.stringify(response));
    }
  }
  handleSetKdvChange = (event) => {

    const { checked } = event.target;
    this.setState((prevState) => ({
      setKdv: checked,
      processes: prevState.processes.map((process) => ({ ...process, kdv: checked ? 20 : 0 }))
    }));
  };
  handleCityChange = async (event) => {
    const city_id = event.target.value;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        customerData: {
          ...prevState.formData.customerData,
          city_id: city_id,
          district_id: ""
        }
      },
      districts: []
    }));
    if (city_id) {
      const response = await apiCall(`get-dist/${city_id}`, 'get', null);
      this.setState({ districts: response });
    }
  }
  getBrands = async () => {
    const response = await apiCall('business/vehicle/get-brands', 'get', null);
    const brandOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ brands: brandOptions });
  }
  getModels = async (brandID) => {
    const response = await apiCall('business/vehicle/get-models/' + brandID, 'get', null);
    const modelOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ models: modelOptions });
  }
  handleBrandChange = async (selectedOption) => {
    const brand_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        vehicleData: {
          ...prevState.formData.vehicleData,
          brand: brand_id,
          model: ""
        }
      },
      selectedBrand: option,
      models: []
    }));

    if (brand_id) {
      try {
        const response = await apiCall(`business/vehicle/get-models/${brand_id}`, 'get', null);

        const modelOptions = response.map(model => ({
          value: model.id,
          label: model.name
        }));
        this.setState({ models: modelOptions });
      } catch (error) {
        console.error("Modelleri alırken hata oluştu:", error);
      }
    }
  }
  handleModelChange = async (selectedOption) => {
    const model_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        vehicleData: {
          ...prevState.formData.vehicleData,
          model: model_id
        }
      },
      selectedModel: option,
    }));
  }
  handleInvoiceChange = (e) => {
    const { files } = e.target;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        operationData: {
          ...prevState.formData.operationData,
          invoice_file: files[0]
        }
      },
    }));
  }
  queueServiceImages = (files) => {
    if (this.state.serviceImagesLoading || this.state.operationLoading || !this.props.userPermissions.includes('update service')) return;
    if (!files.length) return;
    if (files.some(file => !file.type.startsWith('image/') || file.size > 4 * 1024 * 1024)) {
      mainHelper.toastMessage('error', 'Lütfen görsel dosyaları seçin. Her görsel en fazla 4 MB olabilir.');
      return;
    }
    const previews = files.map(file => ({ url: URL.createObjectURL(file), name: file.name }));
    this.setState((prev) => {
      const newFiles = [...(prev.formData.operationData.service_images || []), ...files];
      const newPreviews = [...prev.serviceImagePreviews, ...previews];
      return {
        formData: {
          ...prev.formData,
          operationData: {
            ...prev.formData.operationData,
            service_images: newFiles,
          },
        },
        serviceImagePreviews: newPreviews,
        serviceImagesError: '',
      };
    });
  }
  handleServiceImagesSelect = (e) => {
    this.queueServiceImages(Array.from(e.target.files || []));
    e.target.value = '';
  };
  handleServiceImagesDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragActive: false });
    this.queueServiceImages(Array.from(e.dataTransfer.files || []));
  }
  closeServiceImageUpload = () => {
    if (!this.state.serviceImagesLoading) this.setState({ showServiceImageUpload: false, isDragActive: false });
  };
  finishServiceImageUpload = (images) => {
    this.state.serviceImagePreviews.forEach(preview => URL.revokeObjectURL(preview.url));
    this.setState(previous => ({
      images: images.map(image => ({
        original: image.image_url || `https://apizone.servicezone.com.tr/images/service/${image.image}`,
        thumbnail: image.image_url || `https://apizone.servicezone.com.tr/images/service/${image.image}`,
        name: image.image, storage: image.storage_type || 'local',
      })),
      formData: { ...previous.formData, operationData: { ...previous.formData.operationData, service_images: [] } },
      serviceImagePreviews: [], isDragActive: false,
    }));
  };
  uploadServiceImages = async () => {
    if (this.state.serviceImagesLoading || this.state.operationLoading || !this.props.userPermissions.includes('update service')) return;
    const files = this.state.formData.operationData.service_images;
    if (!files.length) return;
    const data = new FormData();
    files.forEach(file => data.append('service_images[]', file));
    this.setState({ serviceImagesLoading: true, serviceImagesError: '' });
    try {
      const response = await apiCall(`business/operation/upload-images/${this.state.formData.operationData.id}`, 'post', data);
      if (response?.status !== 'success' || !Array.isArray(response.images)) throw new Error(response?.message || 'Görseller yüklenemedi.');
      this.finishServiceImageUpload(response.images);
      this.setState({ showServiceImageUpload: false });
      mainHelper.toastMessage('success', response.message);
    } catch (error) {
      this.setState({ serviceImagesError: error.response?.data?.message
        || Object.values(error.response?.data?.errors || {}).flat().join(' ')
        || error.message || 'Görseller yüklenemedi. Tekrar deneyin.' });
    } finally {
      this.setState({ serviceImagesLoading: false });
    }
  };
  renderServiceImagePicker = () => (
    <ServiceImagePicker inputRef={this.serviceImagesInputRef} previews={this.state.serviceImagePreviews}
      disabled={this.state.serviceImagesLoading || this.state.operationLoading || !this.props.userPermissions.includes('update service')}
      isDragActive={this.state.isDragActive} onSelect={this.handleServiceImagesSelect}
      onDrop={this.handleServiceImagesDrop} onDragOver={this.handleServiceImagesDragOver}
      onDragLeave={this.handleServiceImagesDragLeave} onRemove={this.handleRemoveServiceImage} />
  );
  handleServiceImagesDragOver = (e) => {
    e.preventDefault();
    if (!this.state.isDragActive) this.setState({ isDragActive: true });
  }
  handleServiceImagesDragLeave = () => {
    if (this.state.isDragActive) this.setState({ isDragActive: false });
  }
  handleRemoveServiceImage = (index) => {
    this.setState((prev) => {
      const files = [...(prev.formData.operationData.service_images || [])];
      const previews = [...prev.serviceImagePreviews];
      files.splice(index, 1);
      const removed = previews.splice(index, 1);
      if (removed[0]?.url) URL.revokeObjectURL(removed[0].url);
      return {
        formData: {
          ...prev.formData,
          operationData: {
            ...prev.formData.operationData,
            service_images: files,
          },
        },
        serviceImagePreviews: previews,
      };
    });
  }
  getServiceInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall(`business/operation/info/${id}`, 'get', null);

      const { formData } = this.state;
      const newFormData = {
        ...formData,
        operationData: {
          ...formData.operationData,
          id: response.id,
          version: response.version,
          assigned_employee_id: response.assigned_employee_id || "",
          operation_type_id: response.operation_type_id || "",
          review_count: response.review_count || "",
          description: response.description || '',
          price: response.price || "",
          vehicle_id: response.vehicle?.id || '',
          plate: response.vehicle?.plate || '',
          gen: response.vehicle?.gen || '',
          km: response.km || '',
          year: response.vehicle?.year || '',
          invoice_file_show: response.invoice_file || '',
          invoice_url: response.invoice_url || '',
          invoice_storage_type: response.invoice_storage_type || 'local',
          withholding_amount: response.withholding_amount || '',
          withholding: response.withholding ? JSON.parse(response.withholding)[0].rate : '',
          branch_id: response.vehicle?.branch?.id || '',
          brand: response.vehicle?.brand?.name || '',
          model: response.vehicle?.model?.name || '',
          customer_id: response.vehicle?.customer?.id || '',
          customer_name: response.vehicle?.customer?.name || '',
          customer_surname: response.vehicle?.customer?.surname || '',
        },
        operationStatus: {
          statu_id: response.statu_id || '',
          status_details: Object.prototype.hasOwnProperty.call(response, 'status_details')
            ? (response.status_details ?? '')
            : (response.status?.details ?? ''),
          customer_id: response.vehicle?.customer?.id || '',
        },
      };

      this.setState({
        formData: newFormData,
        kmValue: response.km || '',
        selectedTevkifat: response.withholding && JSON.parse(response.withholding),
        showTevkifatDelButton: !!response.withholding,
        created_at: mainHelper.dateFormat(new Date(response.created_at)),
        processes: this.normalizeProcesses(JSON.parse(response.process)),
        parts: [{ name: "", year: response.vehicle?.year === "null" ? '' : response.vehicle?.year, gen: response.vehicle?.gen === "null" ? '' : response.vehicle?.gen, car_type: "", count: 4 }],
      });
      let serviceImages = [];

      // Sadece S3 service images göster
      if (response.images && Array.isArray(response.images) && response.images.length > 0) {
        serviceImages = response.images.map(img => ({
          original: img.image_url || `https://apizone.servicezone.com.tr/images/service/${img.image}`,
          thumbnail: img.image_url || `https://apizone.servicezone.com.tr/images/service/${img.image}`,
          name: img.image,
          storage: img.storage_type || 'local',
        }));
      }

      if (serviceImages.length === 0) {
        serviceImages.push({
          original: logo,
          thumbnail: logo,
          name: "logo-icon.png",
        });
      }

      // Araç resimlerini state'e kaydet
      let vehicleImages = [];
      if (response.vehicle && response.vehicle.image_urls && response.vehicle.image_urls.length > 0) {
        vehicleImages = response.vehicle.image_urls.filter(url => url !== null);
      }

      this.setState({ images: serviceImages, vehicleImages });
    } catch (error) {
      this.setState({ isLoad: false });
      console.error("Error fetching service info:", error);
    }
  }

  handleVehicleImageClick = (imageUrl) => {
    this.setState({
      showVehicleImageModal: true,
      selectedVehicleImage: imageUrl
    });
  }

  handleCloseVehicleImageModal = () => {
    this.setState({
      showVehicleImageModal: false,
      selectedVehicleImage: null
    });
  }

  openStatusModal = () => {
    this.setState((prevState) => ({
      showStatusModal: true,
      statusModalSnapshot: { ...prevState.formData.operationStatus }
    }));
  };

  closeStatusModal = (restore = true) => {
    this.setState((prevState) => ({
      showStatusModal: false,
      statusModalSnapshot: null,
      formData: restore && prevState.statusModalSnapshot ? {
        ...prevState.formData,
        operationStatus: { ...prevState.statusModalSnapshot }
      } : prevState.formData
    }));
  };

  handleDetailTabChange = (event, activeDetailSection) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ activeDetailSection });
  };

  handleAddProcess = () => {
    this.setState((prevState) => ({
      processes: [...prevState.processes, createEmptyProcess()],
    }), () => {
      window.requestAnimationFrame(() => {
        const newProcessInput = document.getElementById(`process-${this.state.processes.length - 1}`);
        if (newProcessInput) {
          newProcessInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          newProcessInput.focus({ preventScroll: true });
        }
      });
    });
  };
  handleAddMaintenanceProcess = () => {
    const maintenanceItems = [
      "Motor Yağı",
      "Yağ Filtresi",
      "Hava Filtresi",
      "Polen Filtresi",
      "Cam Su İlacı",
      "Temizlik Spreyi",
      "Mekanik Servis Ücreti"
    ];
    this.setState({
      processes: maintenanceItems.map(item => ({
        ...createEmptyProcess(),
        process: item
      }))
    });
  }
  handleRemoveProcess = (index) => {
    this.setState((prevState) => ({
      processes: prevState.processes.filter((_, i) => i !== index),
    }));
  };
  loadSavedLaborProcesses = async () => {
    try {
      const response = await apiCall(`business/operation/info/${this.state.formData.operationData.id}`, 'get');
      const saved = JSON.parse(response.process || '[]');
      this.setState(previous => ({ processes: previous.processes.map((line, index) => {
        const persisted = saved.find(item => item.line_key === line.line_key) || (saved[index]?.process === line.process ? saved[index] : null);
        return persisted ? { ...line, line_key: persisted.line_key, labor_share: persisted.labor_share } : line;
      }) }));
    } catch (error) { mainHelper.toastMessage('warning', 'Hakediş kaydedildi, servis özetini güncellemek için sayfayı yenileyin.'); }
  };
  calculateTotals = () => {
    const { processes } = this.state;
    const withholdingRate = parseFloat(this.state.formData.operationData.withholding) || 0;
    let totalCost = 0;
    let totalPrice = 0;
    let totalWithKdv = 0;
    let totalKdv = 0;
    let totalDiscount = 0;
    let totalWithholding = 0;

    processes.forEach((process) => {
      const cost = parseFloat(process.cost) || 0;
      const quantity = parseFloat(process.quantity) || 0;
      const price = parseFloat(process.price) || 0;
      const kdvRate = parseFloat(process.kdv) || 0;
      const discountRate = parseFloat(process.discount) || 0;

      const discount = (price * quantity * discountRate) / 100;
      totalCost += cost * quantity + lineLaborExtraCost(process);
      totalPrice += price * quantity;
      totalDiscount += discount;

      const discountedPrice = (price * quantity) - discount;
      const kdvAmount = (discountedPrice * kdvRate) / 100;

      totalKdv += kdvAmount;
      totalWithKdv += discountedPrice + kdvAmount;

      const withholdingAmount = (kdvAmount * withholdingRate) / 100;
      totalWithholding += withholdingAmount;

      totalWithKdv -= withholdingAmount;
    });

    totalCost = totalCost.toFixed(2);
    totalPrice = totalPrice.toFixed(2);
    totalWithKdv = totalWithKdv.toFixed(2);
    totalKdv = totalKdv.toFixed(2);
    totalDiscount = totalDiscount.toFixed(2);
    totalWithholding = totalWithholding.toFixed(2);

    return { totalCost, totalPrice, totalWithKdv, totalKdv, totalDiscount, totalWithholding };
  };
  normalizeProcessSearchText = (value = '') => String(value)
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i')
    .replace(/\s+/g, ' ')
    .trim();

  normalizeProcessNames = (items = []) => {
    const uniqueNames = new Map();

    (Array.isArray(items) ? items : []).forEach((item) => {
      const name = String(item?.name || '').trim();
      const normalizedName = this.normalizeProcessSearchText(name);

      if (name && normalizedName && !uniqueNames.has(normalizedName)) {
        uniqueNames.set(normalizedName, { name });
      }
    });

    return Array.from(uniqueNames.values()).sort((first, second) =>
      first.name.localeCompare(second.name, 'tr-TR', { sensitivity: 'base' })
    );
  };

  filterProcessNames = (value = '') => {
    const normalizedQuery = this.normalizeProcessSearchText(value);
    const searchTerms = normalizedQuery.split(' ').filter(Boolean);

    return this.state.processNames
      .filter((item) => {
        const normalizedName = this.normalizeProcessSearchText(item.name);
        return searchTerms.every((term) => normalizedName.includes(term));
      })
      .sort((first, second) => {
        const firstName = this.normalizeProcessSearchText(first.name);
        const secondName = this.normalizeProcessSearchText(second.name);
        const firstStartsWithQuery = normalizedQuery && firstName.startsWith(normalizedQuery);
        const secondStartsWithQuery = normalizedQuery && secondName.startsWith(normalizedQuery);

        if (firstStartsWithQuery !== secondStartsWithQuery) {
          return firstStartsWithQuery ? -1 : 1;
        }

        return first.name.localeCompare(second.name, 'tr-TR', { sensitivity: 'base' });
      });
  };

  handleProcessChange = (index, field, value) => {
    const filteredProcessNames = field === 'process'
      ? this.filterProcessNames(value)
      : this.state.filteredProcessNames;

    this.setState((prevState) => {
      const updatedProcesses = prevState.processes.map((process, i) =>
        i === index ? { ...process, [field]: value } : process
      );
      return {
        processes: updatedProcesses,
        filteredProcessNames,
        showDropdown: field === 'process' ? index : prevState.showDropdown,
      };
    });
  };
  handleNumberInputWheel = (event) => {
    event.currentTarget.blur();
  };
  handleProcessFocus = (index, value) => {
    this.setState({
      filteredProcessNames: this.filterProcessNames(value),
      showDropdown: index,
    });
  };
  handleProcessSelect = (index, name) => {
    this.setState((prevState) => {
      const updatedProcesses = prevState.processes.map((process, i) =>
        i === index ? { ...process, process: name } : process
      );
      return { processes: updatedProcesses, showDropdown: null };
    });
  };
  handleProcessSupplierChange = (index, selectedOption) => {
    this.setState((prevState) => ({
      processes: prevState.processes.map((process, processIndex) => (
        processIndex === index
          ? {
            ...process,
            supplier_id: selectedOption ? selectedOption.value : null,
            supplier_name: selectedOption ? selectedOption.label : null,
          }
          : process
      )),
    }));
  };
  openQuickSupplierModal = (processIndex) => {
    this.setState({
      showQuickSupplierModal: true,
      quickSupplierProcessIndex: processIndex,
    });
  };
  closeQuickSupplierModal = () => {
    this.setState({
      showQuickSupplierModal: false,
      quickSupplierProcessIndex: null,
    });
  };
  handleQuickSupplierCreated = (supplier) => {
    const supplierId = Number(supplier.id);
    const supplierName = this.getSupplierLabel(supplier);

    this.setState((previousState) => ({
      suppliers: [
        ...previousState.suppliers.filter((item) => Number(item.id) !== supplierId),
        supplier,
      ].sort((first, second) => (
        this.getSupplierLabel(first).localeCompare(
          this.getSupplierLabel(second),
          'tr-TR',
          { sensitivity: 'base' }
        )
      )),
      processes: previousState.processes.map((process, processIndex) => (
        processIndex === previousState.quickSupplierProcessIndex
          ? { ...process, supplier_id: supplierId, supplier_name: supplierName }
          : process
      )),
      showQuickSupplierModal: false,
      quickSupplierProcessIndex: null,
    }));
  };
  getProcessName = async () => {
    let cachedProcessNames = [];

    try {
      const storedProcessNames = localStorage.getItem('processNames');
      cachedProcessNames = storedProcessNames
        ? this.normalizeProcessNames(JSON.parse(storedProcessNames))
        : [];

      if (cachedProcessNames.length > 0) {
        this.setState({ processNames: cachedProcessNames });
      }

      const response = await apiCall('business/operation/get-process-name', 'get');
      const processNames = this.normalizeProcessNames(response);
      localStorage.setItem('processNames', JSON.stringify(processNames));
      this.setState({ processNames });
    } catch (e) {
      if (cachedProcessNames.length === 0) {
        this.setState({ processNames: [] });
      }
      console.error(e)
    }
  }
  handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (name === "customerData.customer_id") {
      this.getVehiclesByCustomer(value);
      this.getCustomerParasutData(value);
    }

    const path = name.split('.');

    this.setState(prevState => {
      let updatedData = { ...prevState.formData };
      let currentLevel = updatedData;

      for (let i = 0; i < path.length - 1; i++) {
        if (!currentLevel[path[i]]) {
          currentLevel[path[i]] = {};
        }
        currentLevel = currentLevel[path[i]];
      }

      currentLevel[path[path.length - 1]] = type === "checkbox" ? checked : (files ? Array.from(files) : value);

      return { formData: updatedData };
    });
  }
  handleShowUploadedInvoice = () => {
    const { invoice_url, invoice_storage_type, invoice_file_show, id } = this.state.formData.operationData;

    // S3 URL varsa onu kullan, yoksa local URL oluştur
    let link;
    if (invoice_url) {
      link = invoice_url;
    } else if (invoice_storage_type === 's3' && invoice_file_show) {
      // S3 için fallback (normalde invoice_url olmalı)
      link = `https://servicezone-storage.s3.eu-central-1.amazonaws.com/${invoice_file_show}`;
    } else {
      // Local için eski URL
      link = `${process.env.REACT_APP_MAIN_URL}/invoice/uploaded/${id}`;
    }

    window.open(link, '_blank');
  };
  handleDeleteUploadedInvoice = async () => {
    const { prevData } = this.state.formData.operationData.invoice_file_show;

    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/invoice/uploaded/delete/' + this.state.formData.operationData.id, 'delete')
          this.setState(prevState => ({
            formData: {
              ...prevState.formData,
              operationData: {
                ...prevState.formData.operationData,
                invoice_file_show: '',
                invoice_url: '',
                invoice_storage_type: 'local'
              }
            },
          }));
          return true;
        } catch (error) {
          this.setState({ invoice_file_show: prevData });
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Silindi!',
          'Fatura başarıyla silindi.',
          'success'
        );
      } else {
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  };
  invoiceDetails = async () => {
    const { formData } = this.state;

    // Araç plakası ve km bilgilerini al
    const plate = formData.operationData.plate || '';
    const km = formData.operationData.km || '';

    // Otomatik açıklama oluştur
    const autoDescription = plate ? `${plate} plakalı araç${km ? ` Km:${km}` : ''}` : '';

    // Önce fatura açıklaması için popup göster
    const { value: invoiceDescription } = await Swal.fire({
      title: 'Fatura Açıklaması',
      input: 'textarea',
      inputLabel: 'Fatura açıklaması (opsiyonel)',
      inputPlaceholder: 'Faturaya açıklama eklemek için buraya yazın...',
      inputValue: autoDescription, // Otomatik açıklamayı set et
      inputAttributes: {
        'aria-label': 'Fatura açıklaması girin'
      },
      showCancelButton: true,
      confirmButtonText: 'Devam Et',
      cancelButtonText: 'İptal',
      inputValidator: (value) => {
        // Zorunlu değil, boş olabilir
        return null;
      }
    });

    if (invoiceDescription === undefined) {
      // Kullanıcı iptal etti
      return;
    }

    try {
      Swal.fire({
        title: 'Bilgiler kontrol ediliyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      // Açıklama varsa API'ye gönder
      const apiUrl = invoiceDescription && invoiceDescription.trim()
        ? `business/ksoft/check-account/${formData.operationData.id}?description=${encodeURIComponent(invoiceDescription.trim())}`
        : `business/ksoft/check-account/${formData.operationData.id}`;

      const response = await apiCall(apiUrl, 'get', null);

      if (response.status === "error") {
        const missingFields = response.missing_fields;

        const formatMissingFields = (fields) => {
          let messages = [];

          if (fields.processes) {
            fields.processes.forEach((process, index) => {
              Object.keys(process).forEach((key) => {
                messages.push(`<b>Process ${index + 1}</b> - ${key}: ${process[key]}`);
              });
            });
          }

          if (fields.service) {
            Object.keys(fields.service).forEach((key) => {
              messages.push(`<b>İşletme</b> - ${fields.service[key]}`);
            });
          }
          if (fields.customer) {
            Object.keys(fields.customer).forEach((key) => {
              messages.push(`<b>Müşteri</b> - ${fields.customer[key]}`);
            });
          }
          if (fields.settings) {
            Object.keys(fields.settings).forEach((key) => {
              messages.push(`<b>İşletme Ayarları</b> - ${fields.settings[key]}`);
            });
          }
          if (fields.operation) {
            Object.keys(fields.operation).forEach((key) => {
              messages.push(`<b>Servis Detayları</b> - ${fields.operation[key]}`);
            });
          }

          return messages.join('<br>');
        };
        const errorMessage = formatMissingFields(missingFields);
        Swal.close();
        Swal.fire({
          title: 'Eksik Alanlar!',
          html: `Fatura işlemleri için aşağıdaki alanlar eksik:<br><br>${errorMessage}`,
          icon: 'warning',
          confirmButtonText: 'Tamam',
          customClass: {
            content: 'text-left',
          }
        });

      } else {
        Swal.close();
        const url = `${process.env.PUBLIC_URL}/invoice/${formData.operationData.id}/${formData.operationData.customer_id}`;
        window.open(url, '_blank');
      }

    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Hata!',
        text: 'Veriler alınırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }
  };
  showExperForm = () => {
    const { formData } = this.state;
    const experData = new FormData();
    experData.append('operation_id', formData.operationData.id);
    const url = `${process.env.REACT_APP_MAIN_URL}/exper-report?operation_id=${formData.operationData.id}`;
    window.open(url, '_blank');
  };
  handleImageDelete = async (name) => {
    const { formData, images } = this.state;
    const prevImgData = images;
    const updatedImages = images.filter(image => image.name !== name);
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et'
    });

    if (result.isConfirmed) {
      try {

        await apiCall('business/vehicle/delete-image', 'post', { vehicleID: formData.operationData.vehicle_id, name: name })
        if (updatedImages.length === 0) {
          this.setState({ images: [{ original: logo, thumbnail: logo, name: "logo-icon.png" }] });
        } else {
          this.setState({ images: updatedImages });
        }
        Swal.fire(
          'Silindi!',
          'Resim başarıyla silindi.',
          'success'
        );
      } catch (error) {
        mainHelper.toastMessage('error', 'Resim silinirken bir hata oluştu.')
        this.setState({ images: prevImgData });
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  };
  checkTaxPayer = async () => {
    try {
      Swal.fire({
        title: 'Sorgulama Yapılıyor...',
        text: 'Lütfen bekleyin, mükellef bilgileri sorgulanıyor...',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const tax_no = this.state.formData.customerData.tax_no;
      if (!tax_no || tax_no.length < 10) {
        Swal.close();
        Swal.fire({
          title: 'Uyarı!',
          text: 'Lütfen geçerli bir VKN/TCKN giriniz (en az 10 haneli).',
          icon: 'warning',
          confirmButtonText: 'Tamam',
          allowOutsideClick: false
        });
        return;
      }

      const response = await apiCall('business/customer/check-taxpayer/' + tax_no, 'get', null);

      if (response.status === 'error') {
        Swal.close();
        Swal.fire({
          title: 'Bilgilendirme',
          html: response.message || 'Bu kişiye ait e-fatura kaydı bulunamadı.',
          icon: 'warning',
          confirmButtonText: 'Tamam',
          allowOutsideClick: false
        });
        return;
      }

      const { data } = response;

      if (!data) {
        Swal.close();
        Swal.fire({
          title: 'Bilgilendirme',
          html: 'Bu kişiye ait e-fatura kaydı bulunamadı.<br><small class="text-muted">Kişi e-arşiv fatura kullanıcısı olabilir.</small>',
          icon: 'warning',
          confirmButtonText: 'Tamam',
          allowOutsideClick: false
        });
        return;
      }

      // Form alanlarını otomatik doldur
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          customerData: {
            ...prevState.formData.customerData,
            title: data.unvan || prevState.formData.customerData.title,
            urn: data.urn || '',
            invoice_type: data.invoice_type || 'EARSIV'
          }
        }
      }));

      Swal.close();

      const messages = [];
      messages.push(`<strong>VKN/TCKN:</strong> ${data.vkn_tckn || 'Yok'}`);
      messages.push(`<strong>Ünvan:</strong> ${data.unvan || 'Yok'}`);
      messages.push(`<strong>URN (Etiket):</strong> ${data.urn || 'Yok'}`);
      messages.push(`<strong>Fatura Tipi:</strong> <span style="color: ${data.invoice_type === 'EFATURA' ? '#28a745' : '#ff9800'}; font-weight: bold;">${data.invoice_type || 'EARSIV'}</span>`);
      if (data.tip) messages.push(`<strong>Tip:</strong> ${data.tip}`);

      Swal.fire({
        title: 'İşlem tamamlandı!',
        html: messages.join('<br>'),
        icon: 'success',
        confirmButtonText: 'Tamam',
        allowOutsideClick: false
      });

    } catch (error) {
      console.error('checkTaxPayer error:', error);
      Swal.close();
      Swal.fire({
        title: 'Hata!',
        text: error?.response?.data?.message || error.message || 'Mükellef sorgulanırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam',
        allowOutsideClick: false
      });
    }
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    const loadingStates = {
      'operationStatus': 'statusLoading',
      'processData': 'processLoading',
      'operationData': 'operationLoading',
      'customerData': 'customerLoading',
      'vehicleData': 'vehicleLoading',
    };
    const targetId = e.target.id;

    this.setState((prevState) => ({
      ...prevState,
      [loadingStates[targetId]]: true
    }));

    const { formData } = this.state;
    const data = new FormData();
    const form = formData[e.target.id];
    const formUrls = {
      'customerData': "business/customer/update/" + formData.customerData.id,
      'vehicleData': "business/vehicle/update/" + formData.vehicleData.id,
      'operationData': "business/operation/update-operation-info-update/" + formData.operationData.id,
      'operationStatus': "business/operation/update-status/" + formData.operationData.id,
      'processData': "business/operation/process-data/" + formData.operationData.id,
    };

    if (e.target.id === 'operationData') data.append('_version',formData.operationData.version || '');
    if (e.target.id === "processData") {
      data.append('process', JSON.stringify(this.state.processes));
      data.append('_version', formData.operationData.version || '');
    } else {
      Object.keys(form).forEach(key => {
        if (Array.isArray(form[key])) {
          form[key].forEach(file => {
            data.append(`${key}[]`, file);
          });
        } else {
          data.append(key, form[key]);
        }
      });
    }

    try {
      const response = await apiCall(formUrls[e.target.id], 'post', data, { form: e.target });
      if (response.version) this.setState(prev=>({formData:{...prev.formData,operationData:{...prev.formData.operationData,version:response.version}}}));

      if (e.target.id === "processData") {
        if (response.new && Array.isArray(response.new)) {
          const updatedProcessNames = this.normalizeProcessNames([
            ...this.state.processNames,
            ...response.new,
          ]);
          localStorage.setItem('processNames', JSON.stringify(updatedProcessNames));
          this.setState({ processNames: updatedProcessNames });
        }
        if (response.version) this.setState(prev => ({ formData: { ...prev.formData, operationData: { ...prev.formData.operationData, version: response.version } } }));
        if (response.processes && Array.isArray(response.processes)) {
          this.setState({ processes: this.normalizeProcesses(response.processes) });
        }
      }

      if (targetId === 'operationData') {
        if (response.status === 'success' && formData.operationData.service_images.length && Array.isArray(response.images)) {
          this.finishServiceImageUpload(response.images);
        }
        this.setState(prevState => ({
          formData: {
            ...prevState.formData,
            operationData: {
              ...prevState.formData.operationData,
              invoice_file_show: response.invoice || response.invoice_file || prevState.formData.operationData.invoice_file_show,
              invoice_url: response.invoice_url || prevState.formData.operationData.invoice_url,
              invoice_storage_type: response.invoice_storage_type || prevState.formData.operationData.invoice_storage_type || 's3'
            }
          },
        }));
      }

      if (targetId === 'operationStatus' && response.status === 'success') {
        this.setState({ showStatusModal: false, statusModalSnapshot: null });
      }

      this.setState((prevState) => ({
        ...prevState,
        [loadingStates[targetId]]: false
      }));
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState((prevState) => ({
        ...prevState,
        [loadingStates[targetId]]: false
      }));

    }
  };
  customerDetail = async () => {
    try {
      Swal.fire({
        title: 'Yükleniyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
      const { formData } = this.state;

      const response = await apiCall(`business/customer/info/${formData.operationStatus.customer_id}`, 'get', null);
      if (response.city && response.city.id) {
        var dist = await apiCall(`get-dist/${response.city.id}`, 'get', null);
      } else {
        dist = '';
      }
      const updatedCustomerData = {
        ...formData,
        customerData: {
          ...formData.customerData,
          id: response.id,
          version: response.version,
          p_id: response.p_id,
          name: response.name,
          surname: response.surname,
          phone: response.phone || '',
          address: response.address || '',
          email: response.email || '',
          tax_district: response.tax_district || '',
          tax_no: response.tax_no || '',
          title: response.title || '',
          city_id: response.city?.id || '',
          district_id: response.district?.id || '',
          is_supplier: response.is_supplier === 0 ? 0 : 1,
          save_parasut: response.save_parasut === 1,
          urn: response.urn || '',
          invoice_type: response.invoice_type || 'EARSIV'
        }
      };

      this.setState({
        formData: updatedCustomerData,
        customerLoading: false,
        districts: dist,
      });
      Swal.close();
      this.props.openCustomerDetailModel();
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Müşteri Bilgileri',
        text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);

    }
  }
  calculatePartsCost = async () => {
    try {

      const { formData } = this.state;
      for (let parts of this.state.parts) {
        if (!parts.name || !parts.year || !parts.car_type || parts.count > 5) {
          Swal.close();
          Swal.fire({
            title: 'Eksik veya Hatalı Parça Bilgisi',
            html: `
        <p>Lütfen aşağıdaki bilgileri kontrol ediniz!</p>
        <ul style="list-style-type: none">
          <li style="font-weight: bold">Parça adı boş olamaz</li>
          <li style="font-weight: bold">Model boş olamaz</li>
          <li style="font-weight: bold">Araç boş olamaz</li>
          <li style="font-weight: bold">Sorgu Adedi: Her parça için Max 5 adet olabilir.</li>
        </ul>
      `,
            icon: 'warning',
            confirmButtonText: 'Tamam'
          });
          return;
        }
      }
      Swal.fire({
        title: 'Parça Verileri Alınıyor',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const partsResults = [];

      for (let part of this.state.parts) {
        const query = `"${formData.operationData.brand} ${formData.operationData.model} ${part.year} ${part.gen} ${part.car_type} ${part.name} ${part.part_type}"`;
        const partInfo = await axios.post(`https://apitest.servicezone.com.tr/scrape?query=${query}&count=${part.count}&part_type=${part.part_type}&api_key=9HSXzuQpec10Skm0QoVgWYQb06wECI88`);

        const prices = partInfo.data.map(p => {
          const normalizedPrice = p.price.replace('₺', '').replace(/\./g, '').replace(',', '.');
          return parseFloat(normalizedPrice);
        });

        const averagePrice = prices.reduce((sum, price) => sum + price, 0) / prices.length;

        partsResults.push({ name: part.name, count: part.count, partItems: partInfo.data, averagePrice: averagePrice.toFixed(2) });
      }

      this.setState({ partsResults })
      Swal.close();

    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Hata',
        text: 'Bir sorun oluştu, lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);
    }
  };
  vehicleDetail = async () => {
    try {
      Swal.fire({
        title: 'Yükleniyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
      const { formData } = this.state;
      const response = await apiCall(`business/vehicle/info/${formData.operationData.vehicle_id}`, 'get', null);
      await this.getModels(response.brand.id);
      const updatedVehicleData = {
        ...formData,
        vehicleData: {
          ...formData.vehicleData,
          id: response.id,
          version: response.version,
          brand: response.brand.id,
          branch_id: response.branch.id,
          model: response.model.id,
          plate: response.plate,
          year: response.year,
          km: response.km,
          chassis_no: response.chassis_no,
          engine_no: response.engine_no || '',
          package_name: response.package_name || '',
          engine_size: response.engine_size || '',
          key_no: response.key_no || '',
          details: response.details || '',
          vehicleImages: '',
          maintenance_date: response.maintenance[0]?.maintenance_date || '',
          next_maintenance_date: response.maintenance[0]?.next_maintenance_date || '',
          inspection_date: response.inspection[0]?.inspection_date || '',
          next_inspection_date: response.inspection[0]?.next_inspection_date || '',
          gear_type: response.gear_type || ''
        }
      };
      const selectedBrandOption = {
        value: response.brand.id,
        label: response.brand.name,
      }
      const selectedModelOption = {
        value: response.model.id,
        label: response.model.name,
      }
      this.setState({
        formData: updatedVehicleData,
        vehicleLoading: false,
        selectedBrand: selectedBrandOption,
        selectedModel: selectedModelOption,
      });
      Swal.close();
      this.props.openVehicleDetailModel();
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Araç Bilgileri',
        text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);

    }
  }
  tevkifat = async (index) => {
    try {
      let tevkifatOptions = JSON.parse(localStorage.getItem('tevkifatOptions'));
      if (!tevkifatOptions) {
        const response = await apiCall('business/invoice/tevkifat', 'get', null);
        tevkifatOptions = Object.keys(response).map(key => ({
          value: key,
          label: response[key].name,
          rate: response[key].rate
        }));
        localStorage.setItem('tevkifatOptions', JSON.stringify(tevkifatOptions));
      }
      this.setState({ tevkifat: tevkifatOptions, showTevkifatForm: index });
    } catch (e) {
      this.setState({ loading: false });
      mainHelper.handleErrors(e.response.data.errors);
    }

  }
  handleTevkifatChange = (selectedOption) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        operationData: {
          ...prevState.formData.operationData,
          withholding: selectedOption.rate
        }
      },
      selectedTevkifat: selectedOption
    }), () => {

      this.calculateTotals();
    });
  };
  handleWithholdingSubmit = async (e) => {
    e.preventDefault();
    const { totalWithholding, totalWithKdv } = this.calculateTotals();
    this.setState({ tevLoading: true });
    try {
      const response = await apiCall('business/parasut/withholding/add/' + this.state.formData.operationData.id, 'post',
        { _version:this.state.formData.operationData.version, tevkifat: JSON.stringify(this.state.selectedTevkifat), withholding_amount: totalWithholding, net_total: totalWithKdv });
      if(response.version)this.setState(prev=>({formData:{...prev.formData,operationData:{...prev.formData.operationData,version:response.version}}}));
      this.setState({ tevLoading: false, showTevkifatDelButton: true });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ tevLoading: false });
    }

  };
  handleDeleteWithholding = async (e) => {
    e.preventDefault();
    const { totalWithKdv, totalWithholding } = this.calculateTotals();
    this.setState({ tevDelLoading: true });
    const netTotal = parseFloat(totalWithKdv) + parseFloat(totalWithholding);
    try {
      const response = await apiCall('business/parasut/withholding/remove/' + this.state.formData.operationData.id, 'post',
        { _version:this.state.formData.operationData.version, net_total: netTotal });
      if(response.version)this.setState(prev=>({formData:{...prev.formData,operationData:{...prev.formData.operationData,version:response.version}}}));

      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          operationData: {
            ...prevState.formData.operationData,
            withholding: ''
          }
        },
        selectedTevkifat: '',
        showTevkifatDelButton: false
      }), () => {
        this.setState({ tevDelLoading: false });
        this.calculateTotals();
      });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ tevDelLoading: false });
    }

  };

  toggleWithholdingModal = () => {
    this.setState(prevState => ({
      showWithholdingModal: !prevState.showWithholdingModal
    }));
  };
  toggleEditKm = () => {
    this.setState((prevState) => ({ kmValue: this.state.formData.operationData.km, isEditingKm: !prevState.isEditingKm }));
  };
  saveSummaryField = async (field, value) => {
    if (!this.props.userPermissions.includes('update service')) {
      throw new Error('Servis güncelleme yetkiniz yok.');
    }
    const response = await apiCall(
      `business/operation/update-summary/${this.state.formData.operationData.id}`,
      'post', { [field]: value }
    );
    if (response?.status !== 'success') {
      throw new Error(response?.message || 'Değişiklik kaydedilemedi.');
    }
    this.setState(previousState => ({
      formData: {
        ...previousState.formData,
        operationData: {
          ...previousState.formData.operationData,
          [field]: response.data[field] ?? '',
        },
        ...(field === 'branch_id' ? {
          vehicleData: {
            ...previousState.formData.vehicleData,
            branch_id: response.data.branch_id,
          },
        } : {}),
      },
    }));
    mainHelper.toastMessage(response.status, response.message);
  };
  handleKmChange = (e) => {
    this.setState({ kmValue: e.target.value });
  };
  handleKmSubmit = async () => {
    this.setState({ isEditingKmLoading: true });
    try {
      const response = await apiCall('business/operation/update-km/' + this.state.formData.operationData.id, 'post', { km: this.state.kmValue });
      this.setState({ isEditingKmLoading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ isEditingKmLoading: false });
    }
    this.setState({ isEditingKmLoading: false, isEditingKm: false });
  };
  render() {

    const {
      formData,
      branches,
      types,
      employes,
      images,
      vehicleImages,
      showVehicleImageModal,
      selectedVehicleImage,
      created_at,
      status,
      statusLoading,
      processLoading,
      operationLoading,
      customerLoading,
      vehicleLoading,
      brands, models,
      selectedBrand, selectedModel,
      cities, districts, isMobile, isEditingKm, kmValue, isEditingKmLoading
    } = this.state;
    const { totalCost, totalPrice, totalKdv, totalWithKdv, totalDiscount } = this.calculateTotals();
    const { userPermissions, isVehicleDetailModalOpen, isCustomerDetailModalOpen } = this.props;
    const inspection = formData.vehicleData.inspection_date.split(' ')[0];
    const next_inspection = formData.vehicleData.next_inspection_date.split(' ')[0];
    const maintenance = formData.vehicleData.maintenance_date.split(' ')[0];
    const next_maintenance = formData.vehicleData.next_maintenance_date.split(' ')[0];
    const userHasUpdateServiceCustomerInfo = userPermissions.includes('update service customer');
    const userHasUpdateServiceStatus = userPermissions.includes('update service status');
    const userHasUpdateServiceInfo = userPermissions.includes('update service');
    const userHasUpdateServiceVehicleInfo = userPermissions.includes('update service vehicle');
    const userHasUpdateServiceProcess = userPermissions.includes('update service process');
    const userHasNewCustomerPermission = userPermissions.includes('new customer');
    const userHasViewServiceForm = userPermissions.includes('view form');
    const statusComplete = Object.keys(status).some(key => {
      if (status[key].id === formData.operationStatus.statu_id && status[key].name === 'Tamamlandı') {
        return true;
      }
      return false;
    });
    const currentStatus = status.find(item => Number(item.id) === Number(formData.operationStatus.statu_id));
    const customerName = [formData.operationData.customer_name, formData.operationData.customer_surname]
      .filter(Boolean).join(' ') || 'Müşteri belirtilmemiş';
    const vehicleName = [formData.operationData.brand, formData.operationData.model]
      .filter(Boolean).join(' ') || 'Araç bilgisi belirtilmemiş';
    const overviewProcesses = this.state.processes.filter(process => process.process);
    return (
      <div className="sd-page" style={{ flex: 1 }} onClick={() => { document.body.classList.remove("offcanvas-active"); }}>
        <div>
          <div className="container-fluid">
            <PageHeader HeaderText="Servis Detayı" Breadcrumb={[
              { name: "Servisler", navigate: "services" },
              { name: "Detay", navigate: "" },
            ]} />
            <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
              <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="m-t-30">
                  <img src={require('../../assets/images/logo-white.png')} width="150" alt="Servicezone" />
                </div>
                <p>Yükleniyor</p>
                <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
              </div>
            </div>
            {/* Customer Detail Modal - Refactored Component */}
            <CustomerDetailModal
              isOpen={isCustomerDetailModalOpen}
              toggle={this.props.closeCustomerDetailModel}
              formData={formData}
              cities={cities}
              districts={districts}
              customerLoading={customerLoading}
              userHasUpdatePermission={userHasUpdateServiceCustomerInfo}
              handleChange={this.handleChange}
              handleCityChange={this.handleCityChange}
              handleSubmit={this.handleSubmit}
              checkTaxPayer={this.checkTaxPayer}
            />
            {/* Vehicle Detail Modal - Refactored Component */}
            <VehicleDetailModal
              isOpen={isVehicleDetailModalOpen}
              toggle={this.props.closeVehicleDetailModel}
              formData={formData}
              brands={brands}
              models={models}
              selectedBrand={selectedBrand}
              selectedModel={selectedModel}
              vehicleImages={vehicleImages}
              vehicleLoading={vehicleLoading}
              userHasUpdatePermission={userHasUpdateServiceVehicleInfo}
              handleChange={this.handleChange}
              handleBrandChange={this.handleBrandChange}
              handleModelChange={this.handleModelChange}
              handleSubmit={this.handleSubmit}
              handleVehicleImageClick={this.handleVehicleImageClick}
              inspection={inspection}
              next_inspection={next_inspection}
              maintenance={maintenance}
              next_maintenance={next_maintenance}
            />
            <QuickSupplierModal
              isOpen={this.state.showQuickSupplierModal}
              toggle={this.closeQuickSupplierModal}
              onCreated={this.handleQuickSupplierCreated}
            />


            {/* Vehicle Image Modal */}
            {showVehicleImageModal && (
              <div className="modal fade show"
                style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.8)' }}
                onClick={this.handleCloseVehicleImageModal}>
                <div className="modal-dialog modal-lg modal-dialog-centered"
                  onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Araç Resmi</h5>
                      <button type="button"
                        className="close"
                        onClick={this.handleCloseVehicleImageModal}>
                        <span>&times;</span>
                      </button>
                    </div>
                    <div className="modal-body text-center" style={{ padding: '20px' }}>
                      <img
                        src={selectedVehicleImage}
                        alt="Vehicle"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '70vh',
                          objectFit: 'contain'
                        }}
                        onError={(e) => {
                          e.target.src = logo;
                        }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button type="button"
                        className="btn btn-secondary"
                        onClick={this.handleCloseVehicleImageModal}>
                        Kapat
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.state.showStatusModal && (
              <div className="sd-modal-backdrop" role="presentation" onMouseDown={() => this.closeStatusModal(true)}>
                <div className="sd-status-modal" role="dialog" aria-modal="true" aria-labelledby="sd-status-modal-title" onMouseDown={(e) => e.stopPropagation()}>
                  <div className="sd-status-modal-header">
                    <div className="sd-status-modal-icon"><i className="fa fa-random" /></div>
                    <div>
                      <span>İŞ AKIŞI</span>
                      <h2 id="sd-status-modal-title">Servis durumunu güncelle</h2>
                      <p>Müşterinin göreceği aşamayı ve kısa açıklamayı belirleyin.</p>
                    </div>
                    <button type="button" className="sd-modal-close" onClick={() => this.closeStatusModal(true)} aria-label="Kapat"><i className="fa fa-times" /></button>
                  </div>
                  <form id="operationStatus" onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="statu_id">Durum</label>
                      <select name="operationStatus.statu_id" id="statu_id" className="form-control"
                        value={formData.operationStatus.statu_id} onChange={this.handleChange}>
                        <option value="">Durum seçin</option>
                        {status.map(statu => <option key={statu.id} value={statu.id}>{statu.name}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="operationStatus.status_details">Müşteriye gösterilecek durum detayı</label>
                      <textarea name="operationStatus.status_details" id="operationStatus.status_details"
                        value={formData.operationStatus.status_details} className="form-control"
                        placeholder="Örn. Parça siparişi verildi, teslimat bekleniyor."
                        onChange={this.handleChange} />
                    </div>
                    <input type="hidden" name="operationStatus.customer_id" id="customer_id"
                      value={formData.customerData.id} onChange={this.handleChange} />
                    {statusComplete && (
                      <div className="sd-warning-note"><i className="fa fa-info-circle" /> Tamamlandı durumunu kaydettiğinizde cari kayıt oluşturulur.</div>
                    )}
                    <div className="sd-status-modal-footer">
                      <button type="button" className="sd-modal-cancel" onClick={() => this.closeStatusModal(true)}>Vazgeç</button>
                      <button disabled={!userHasUpdateServiceStatus || statusLoading} className="sd-save-button" type="submit">
                        {statusLoading ? <><i className="fa fa-circle-o-notch fa-spin" /> Güncelleniyor...</> : <><i className="fa fa-check" /> Durumu güncelle</>}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            <section className="sd-hero">
              <div className="sd-hero-copy">
                <span className="sd-eyebrow"><i className="fa fa-wrench" /> SERVİS #{formData.operationData.id || '-'}</span>
                <div className="sd-title-row">
                  <h1>{(formData.operationData.plate || '-').toUpperCase()}</h1>
                </div>
                <p>{vehicleName} <span>•</span> {customerName}</p>
              </div>
              <div className="sd-hero-actions">
                <button type="button" className={`sd-status-action ${statusComplete ? 'complete' : ''}`}
                  disabled={!userHasUpdateServiceStatus}
                  title={!userHasUpdateServiceStatus ? 'Durum güncelleme yetkiniz yok' : 'Servis durumunu değiştir'}
                  onClick={this.openStatusModal}>
                  <i className={`fa ${statusComplete ? 'fa-check-circle' : 'fa-clock-o'}`} />
                  <span><small>İŞ AKIŞI</small><strong>{currentStatus?.name || 'Durum seçilmedi'}</strong></span>
                  <i className="fa fa-pencil" />
                </button>
                {userHasViewServiceForm && (
                  <button type="button" onClick={this.showExperForm}>
                    <i className="fa fa-file-pdf-o" /><span>Araç formu</span>
                  </button>
                )}
                {/* Fatura oluşturma butonu geçici olarak gizlendi.
                    invoiceDetails fonksiyonu ve fatura akışı korunuyor. */}
              </div>
            </section>

            <nav className="sd-section-nav" aria-label="Servis detay bölümleri" role="tablist">
              <button type="button" role="tab" aria-selected={this.state.activeDetailSection === 'overview'} aria-controls="sd-overview"
                className={this.state.activeDetailSection === 'overview' ? 'active' : ''}
                onClick={(event) => this.handleDetailTabChange(event, 'overview')}><i className="fa fa-th-large" /> Genel bakış</button>
              <button type="button" role="tab" aria-selected={this.state.activeDetailSection === 'service'} aria-controls="sd-service-info"
                className={this.state.activeDetailSection === 'service' ? 'active' : ''}
                onClick={(event) => this.handleDetailTabChange(event, 'service')}><i className="fa fa-clipboard" /> Servis bilgileri</button>
              <button type="button" role="tab" aria-selected={this.state.activeDetailSection === 'processes'} aria-controls="sd-processes"
                className={this.state.activeDetailSection === 'processes' ? 'active' : ''}
                onClick={(event) => this.handleDetailTabChange(event, 'processes')}><i className="fa fa-cogs" /> Ürün ve hizmetler</button>
              {userHasUpdateServiceProcess && <button type="button" role="tab" aria-selected={this.state.activeDetailSection === 'labor'} aria-controls="sd-labor"
                className={this.state.activeDetailSection === 'labor' ? 'active' : ''}
                onClick={(event) => this.handleDetailTabChange(event, 'labor')}><i className="fa fa-handshake-o" /> Hakediş</button>}
            </nav>

            {this.state.activeDetailSection === 'labor' && userHasUpdateServiceProcess && <div className="sd-tab-content" id="sd-labor">
              <ServiceLaborCommission operationId={formData.operationData.id} onSaved={() => this.loadSavedLaborProcesses()} />
            </div>}

            {this.state.activeDetailSection === 'overview' && (
              <div className="sd-tab-content" id="sd-overview">
                <section className="sd-overview-grid">
                  <div className="sd-panel sd-gallery-panel">
                    <div className="sd-section-heading">
                      <div><span>GÖRSEL KAYIT</span><h2>Servis fotoğrafları</h2><p>İşlem öncesi ve sonrası araç görselleri.</p></div>
                      <div className="sd-gallery-actions">
                        <span className="sd-count-badge">{images.filter(image => image.name !== 'logo-icon.png').length} görsel</span>
                        {userHasUpdateServiceInfo && <button type="button" className="sd-open-tab-button"
                          disabled={operationLoading || this.state.serviceImagesLoading}
                          onClick={() => this.setState({ showServiceImageUpload: true, serviceImagesError: '' })}>
                          <i className="fa fa-camera" /> Fotoğraf ekle
                        </button>}
                      </div>
                    </div>
                    <Modal isOpen={this.state.showServiceImageUpload} toggle={this.closeServiceImageUpload}
                      centered contentClassName="sd-image-upload-modal" keyboard={!this.state.serviceImagesLoading}
                      backdrop={this.state.serviceImagesLoading ? 'static' : true}>
                      <ModalHeader toggle={this.state.serviceImagesLoading ? undefined : this.closeServiceImageUpload}>Servis fotoğrafları ekle</ModalHeader>
                      <ModalBody>
                        <p>Fotoğrafları seçip yükleyin. Diğer servis bilgileri değişmez.</p>
                        {this.renderServiceImagePicker()}
                        {this.state.serviceImagesError && <div className="sd-image-upload-error" role="alert">{this.state.serviceImagesError}</div>}
                      </ModalBody>
                      <ModalFooter>
                        <button type="button" className="sd-modal-cancel" disabled={this.state.serviceImagesLoading} onClick={this.closeServiceImageUpload}>Kapat</button>
                        <button type="button" className="sd-save-button" onClick={this.uploadServiceImages}
                          disabled={this.state.serviceImagesLoading || !this.state.serviceImagePreviews.length || !userHasUpdateServiceInfo}>
                          <i className={`fa ${this.state.serviceImagesLoading ? 'fa-circle-o-notch fa-spin' : 'fa-cloud-upload'}`} />
                          {this.state.serviceImagesLoading ? 'Yükleniyor...' : `Fotoğrafları yükle (${this.state.serviceImagePreviews.length})`}
                        </button>
                      </ModalFooter>
                    </Modal>
                    <ServiceImageGallery
                      images={images}
                      constrainHeight
                      title=""
                      loading={lazy}
                      userHasDeletePermission={userPermissions.includes('delete service vehicle image')}
                      onImageDelete={this.handleImageDelete}
                    />
                  </div>

                  <div className="sd-panel sd-record-panel">
                    <div className="sd-section-heading">
                      <div><span>KAYIT ÖZETİ</span><h2>Araç ve müşteri</h2></div>
                    </div>
                    <div className="sd-summary-grid">
                      <div className="sd-summary-item featured"><i className="fa fa-user" /><span><small>MÜŞTERİ</small><strong>{customerName}</strong></span><button onClick={this.customerDetail} type="button" title="Müşteri detayını aç"><i className="icon-eye" /></button></div>
                      <div className="sd-summary-item featured"><i className="fa fa-car" /><span><small>ARAÇ</small><strong>{vehicleName}</strong></span><button onClick={this.vehicleDetail} type="button" title="Araç detayını aç"><i className="icon-eye" /></button></div>
                      <ServiceSummarySelect label="ŞUBE" icon="fa-building"
                        value={formData.operationData.branch_id} placeholder="Şube seçiniz"
                        options={branches.map(branch => ({ value: branch.id, label: branch.name }))}
                        canEdit={userHasUpdateServiceInfo} canClear={false}
                        onSave={value => this.saveSummaryField('branch_id', value)} />
                      <ServiceSummarySelect label="SERVİS TİPİ" icon="fa-wrench"
                        value={formData.operationData.operation_type_id} placeholder="Seçilmedi"
                        options={types.map(type => ({ value: type.id, label: type.name }))}
                        canEdit={userHasUpdateServiceInfo}
                        onSave={value => this.saveSummaryField('operation_type_id', value)} />
                      <ServiceSummarySelect label="ATANAN PERSONEL" icon="fa-user-circle"
                        value={formData.operationData.assigned_employee_id} placeholder="Atanmadı"
                        options={employes.map(employee => ({ value: employee.id, label: [employee.name, employee.surname].filter(Boolean).join(' ') }))}
                        canEdit={userHasUpdateServiceInfo}
                        onSave={value => this.saveSummaryField('assigned_employee_id', value)} />
                      <div className={`sd-summary-item sd-km-item${isEditingKm ? ' editing' : ''}`}><i className="fa fa-tachometer" /><span><small>KİLOMETRE</small>{isEditingKm ? <span className="sd-km-edit"><input type="number" min="0" value={kmValue} onWheel={this.handleNumberInputWheel} onChange={this.handleKmChange} /><button type="button" disabled={isEditingKmLoading} onClick={this.handleKmSubmit}>{isEditingKmLoading ? <i className="fa fa-circle-o-notch fa-spin" /> : <i className="fa fa-check" />}</button><button type="button" className="cancel" onClick={this.toggleEditKm}><i className="fa fa-times" /></button></span> : <strong>{Number(kmValue || 0).toLocaleString('tr-TR')} km <button type="button" onClick={this.toggleEditKm}><i className="icon-pencil" /></button></strong>}</span></div>
                      <div className="sd-summary-item"><i className="fa fa-calendar" /><span><small>OLUŞTURULMA</small><strong>{created_at || '-'}</strong></span></div>
                      <div className="sd-summary-item total"><i className="fa fa-try" /><span><small>SERVİS TOPLAMI</small><strong>{formattedPrice(totalWithKdv) || 0}</strong></span></div>
                      {statusComplete && <div className="sd-summary-item"><i className="fa fa-star" /><span><small>MÜŞTERİ PUANI</small><strong>{formData.operationData.review_count ? `${formData.operationData.review_count} / 5` : 'Değerlendirilmedi'}</strong></span></div>}
                    </div>
                    <ServiceSummaryDescription value={formData.operationData.description}
                      canEdit={userHasUpdateServiceInfo}
                      onSave={value => this.saveSummaryField('description', value)} />
                    <section className="sd-compact-processes" aria-labelledby="sd-summary-processes-title">
                      <div className="sd-section-heading">
                        <div><h3 id="sd-summary-processes-title">Servis kalemleri <span className="sd-count-badge">{overviewProcesses.length}</span></h3></div>
                        <button type="button" className="sd-open-tab-button" onClick={(event) => this.handleDetailTabChange(event, 'processes')}>Tümünü yönet <i className="fa fa-arrow-right" /></button>
                      </div>
                      {overviewProcesses.length ? (
                        <div className="sd-compact-process-list" role="region" aria-label="Servis kalemleri listesi" tabIndex={0}>
                          {overviewProcesses.map((process, index) => (
                            <div className="sd-compact-process-item" key={process.line_key || index}>
                              <span className="sd-compact-process-index">{String(index + 1).padStart(2, '0')}</span>
                              <span className="sd-compact-process-name"><strong title={process.process}>{process.process}</strong><small title={process.supplier_name || 'Tedarikçi belirtilmedi'}>{Number(process.quantity || 0).toLocaleString('tr-TR')} adet · {process.supplier_name || 'Tedarikçi belirtilmedi'}</small></span>
                              <span className="sd-compact-process-price"><small>BİRİM FİYAT</small><strong>{formattedPrice(process.price || 0)}</strong></span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="sd-compact-empty"><i className="fa fa-cubes" /><span><strong>Henüz servis kalemi eklenmedi</strong><small>Ürün ve hizmetler tabından ilk kalemi ekleyebilirsiniz.</small></span></div>
                      )}
                    </section>
                  </div>
                </section>
              </div>
            )}
            {this.state.activeDetailSection === 'service' && (
            <div id="sd-service-info" className="row clearfix sd-form-section sd-tab-content">
              <div className="col-lg-12 col-md-12">
                <div className="card sd-panel">
                  <div className="card-body">
                    <div className="sd-section-heading">
                      <div><span>OPERASYON</span><h2>Servis bilgileri</h2><p>Şube, sorumlu personel, servis tipi, açıklama ve dosyaları yönetin.</p></div>
                      {this.state.formData.operationData.invoice_file_show && (
                        <div className="sd-heading-actions">
                          <button onClick={this.handleShowUploadedInvoice} title="Yüklenen faturayı görüntüle" type="button"><i className="fa fa-file-text-o" /> Faturayı aç</button>
                          <button onClick={this.handleDeleteUploadedInvoice} title="Yüklenen faturayı sil" type="button" className="danger"><i className="fa fa-trash" /></button>
                        </div>
                      )}
                    </div>

                    <form id="operationData" className="sd-operation-form" onSubmit={this.handleSubmit}>
                      {/* 1. SATIR: form alanları */}
                      <div className="row">
                        <div className="col-lg-3 col-md-6">
                          <div className="form-group">
                            <label htmlFor="branch_id">
                              Şube
                            </label>
                            <select
                              name="operationData.branch_id"
                              id="branch_id"
                              className="form-control"
                              value={this.state.formData.operationData.branch_id}
                              onChange={this.handleChange}
                            >
                              <option value="">Şube Seçiniz</option>
                              {branches &&
                                branches.map((branch) => (
                                  <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="form-group">
                            <label htmlFor="assigned_employee_id">
                              Atanan personel
                            </label>
                            <select
                              name="operationData.assigned_employee_id"
                              id="assigned_employee_id"
                              className="form-control"
                              value={this.state.formData.operationData.assigned_employee_id}
                              onChange={this.handleChange}
                            >
                              <option value="">Personel Seçiniz</option>
                              {employes &&
                                employes.map((employe) => (
                                  <option key={employe.id} value={employe.id}>
                                    {employe.name} {employe.surname}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="form-group">
                            <label htmlFor="operation_type_id">
                              Servis tipi
                            </label>
                            <select
                              name="operationData.operation_type_id"
                              id="operation_type_id"
                              className="form-control"
                              value={this.state.formData.operationData.operation_type_id}
                              onChange={this.handleChange}
                            >
                              <option value="">Servis Tipi Seçiniz</option>
                              {types &&
                                types.map((type) => (
                                  <option key={type.id} value={type.id}>
                                    {type.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="form-group">
                            <label htmlFor="invoice_file">
                              Fatura dosyası
                            </label>
                            <input
                              name="operationData.invoice_file"
                              id="invoice_file"
                              className="form-control"
                              type="file"
                              accept="application/pdf,image/*"
                              onChange={this.handleInvoiceChange}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="description">
                              Servis Açıklaması
                            </label>
                            <textarea
                              name="operationData.description"
                              value={this.state.formData.operationData.description}
                              id="description"
                              className="form-control textarea-height-detail"
                              placeholder="Servis Açıklaması"
                              onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                            <label>Yeni servis görselleri</label>
                            {this.renderServiceImagePicker()}
                          </div>
                        </div>
                      </div>
                      {/* 1. row bitti */}

                      {/* 2. SATIR: submit butonu */}
                      <div className="sd-form-submit-row">
                        {operationLoading ? (
                          <button className="sd-save-button" disabled>
                            <i className="fa fa-circle-o-notch fa-spin" /> Güncelleniyor...
                          </button>
                        ) : (
                          <button disabled={!userHasUpdateServiceInfo} className="sd-save-button" type="submit">
                            <i className="fa fa-check" /> Servis bilgilerini güncelle
                          </button>
                        )}
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
            )}

            {this.state.activeDetailSection === 'processes' && (
            <div id="sd-processes" className="row sd-process-section sd-tab-content">
              <div className="col-lg-12 col-md-12">
                <div className="card sd-panel">
                  <div className="card-body">
                    <div className="sd-section-heading sd-process-heading">
                      <div><span>FİYATLANDIRMA</span><h2>Ürün ve hizmetler</h2><p>Yapılan işleri, kullanılan ürünleri, tedarikçileri ve fiyatları satır bazında yönetin.</p></div>
                    </div>

                    <form id="processData" className="sd-process-form" onSubmit={this.handleSubmit}>
                      <div className="sd-process-command-bar">
                        <div className="sd-command-summary">
                          <div><small>MALİYET</small><strong>{formattedPrice(totalCost)}</strong></div>
                          <div><small>ARA TOPLAM</small><strong>{formattedPrice(totalPrice)}</strong></div>
                          <div><small>KDV</small><strong>{formattedPrice(totalKdv)}</strong></div>
                          <div><small>İNDİRİM</small><strong>{formattedPrice(totalDiscount)}</strong></div>
                          {/* Tevkifat özeti geçici olarak gizlendi; hesaplama fonksiyonları korunuyor. */}
                          <div className="total"><small>GENEL TOPLAM</small><strong>{formattedPrice(totalWithKdv)}</strong></div>
                        </div>
                        <div className="sd-command-actions">
                          <label htmlFor="setKdv" className="sd-kdv-toggle" title="Tüm servis kalemlerine %20 KDV uygula">
                            <input name="setKdv" id="setKdv" type="checkbox" checked={this.state.setKdv} onChange={this.handleSetKdvChange} />
                            <span>Tümüne %20 KDV</span>
                          </label>
                          {/* Tevkifat ekleme butonu geçici olarak gizlendi; toggleWithholdingModal korunuyor. */}
                          <button type="button" className="secondary" onClick={this.handleAddMaintenanceProcess}><i className="fa fa-wrench" /> Bakım işleri</button>
                          <button type="button" className="primary" onClick={this.handleAddProcess}><i className="fa fa-plus" /> Yeni kalem</button>
                        </div>
                      </div>

                      {this.state.processes.map((process, index) => (
                        <div key={process.line_key || index} className="form-row align-items-end sd-process-row">
                          <div className="sd-process-row-title"><span>{String(index + 1).padStart(2, '0')}</span><strong>Servis kalemi</strong></div>
                          <div className="col-lg-3 col-md-6">
                            <label htmlFor={`process-${index}`} className="font-weight-bold small">
                              Ürün/Hizmet
                            </label>
                            <div className="modern-dropdown-wrapper">
                              <input
                                type="text"
                                className="form-control modern-dropdown-input"
                                id={`process-${index}`}
                                placeholder="Ürün veya hizmet ara..."
                                value={process.process}
                                onChange={(e) => this.handleProcessChange(index, "process", e.target.value)}
                                onFocus={() => this.handleProcessFocus(index, process.process)}
                                role="combobox"
                                aria-expanded={this.state.showDropdown === index}
                                aria-controls={`process-dropdown-${index}`}
                                autoComplete="off"
                              />
                              {this.state.showDropdown === index && (
                                <div
                                  id={`process-dropdown-${index}`}
                                  className="modern-dropdown-menu modern-dropdown-menu--service-detail"
                                  role="listbox"
                                  onTouchStart={(e) => e.stopPropagation()}
                                  onTouchMove={(e) => e.stopPropagation()}
                                >
                                  {this.state.filteredProcessNames.length > 0 ? (
                                    <>
                                      <div className="modern-dropdown-summary">
                                        <span>Ürün ve hizmetler</span>
                                        <span className="modern-dropdown-count">
                                          {this.state.filteredProcessNames.length} sonuç
                                        </span>
                                      </div>
                                      {this.state.filteredProcessNames.map((nameObj) => (
                                        <div
                                          key={nameObj.name}
                                          onMouseDown={(event) => event.preventDefault()}
                                          onClick={() => this.handleProcessSelect(index, nameObj.name.trim())}
                                          className="modern-dropdown-item"
                                          role="option"
                                          aria-selected={process.process.trim() === nameObj.name.trim()}
                                          title={nameObj.name.trim()}
                                        >
                                          <div className="modern-dropdown-item-icon">
                                            <i className="fa fa-cube"></i>
                                          </div>
                                          <span className="modern-dropdown-item-text">
                                            {nameObj.name.trim()}
                                          </span>
                                        </div>
                                      ))}
                                    </>
                                  ) : (
                                    <div className="modern-dropdown-empty">
                                      <div className="modern-dropdown-empty-icon">
                                        <i className="fa fa-search"></i>
                                      </div>
                                      <p className="modern-dropdown-empty-text">
                                        Sonuç bulunamadı
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-6">
                            <div className="d-flex align-items-center justify-content-between mb-1">
                              <label htmlFor={`supplier-${index}`} className="font-weight-bold small mb-0">
                                Tedarikçi <span className="text-muted font-weight-normal">(opsiyonel)</span>
                              </label>
                              <button
                                type="button"
                                className="btn btn-link btn-sm p-0"
                                onClick={() => this.openQuickSupplierModal(index)}
                                disabled={!userHasNewCustomerPermission}
                                title={userHasNewCustomerPermission
                                  ? 'Yeni tedarikçi oluştur'
                                  : 'Tedarikçi oluşturma yetkiniz bulunmuyor'}
                              >
                                <i className="fa fa-plus-circle mr-1"></i>
                                Yeni Tedarikçi
                              </button>
                            </div>
                            <Select
                              inputId={`supplier-${index}`}
                              classNamePrefix="process-supplier-select"
                              value={process.supplier_id ? {
                                value: Number(process.supplier_id),
                                label: process.supplier_name
                                  || this.getSupplierLabel(this.state.suppliers.find(
                                    (supplier) => Number(supplier.id) === Number(process.supplier_id)
                                  )),
                              } : null}
                              options={this.state.suppliers.map((supplier) => ({
                                value: Number(supplier.id),
                                label: this.getSupplierLabel(supplier),
                              }))}
                              onChange={(selectedOption) => this.handleProcessSupplierChange(index, selectedOption)}
                              placeholder="Tedarikçi ara/seç..."
                              noOptionsMessage={() => "Tedarikçi bulunamadı"}
                              isClearable
                              isSearchable
                              isLoading={this.state.suppliersLoading}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({ ...base, minHeight: '38px' }),
                              }}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`unit-${index}`} className="font-weight-bold small">Birim</label>
                            <select
                              id={`unit-${index}`}
                              className="form-control"
                              value={process.unit}
                              onChange={(e) => this.handleProcessChange(index, "unit", e.target.value)}
                            >
                              <option value="">Seçiniz</option>
                              <option value="C62">Adet</option>
                              <option value="KGM">Kg</option>
                              <option value="LTR">Litre</option>
                              <option value="MTK">Metre Kare</option>
                              <option value="MTQ">Metre Küp</option>
                              <option value="PR">Çift</option>
                            </select>
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`quantity-${index}`} className="font-weight-bold small">Miktar</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`quantity-${index}`}
                              placeholder="Miktar"
                              value={process.quantity}
                              onChange={(e) => this.handleProcessChange(index, "quantity", e.target.value)}
                              onWheel={this.handleNumberInputWheel}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`kdv-${index}`} className="font-weight-bold small">KDV (%)</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`kdv-${index}`}
                              placeholder="Kdv Oranı"
                              value={process.kdv}
                              onChange={(e) => this.handleProcessChange(index, "kdv", e.target.value)}
                              onWheel={this.handleNumberInputWheel}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`discount-${index}`} className="font-weight-bold small">İndirim (%)</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`discount-${index}`}
                              placeholder="İndirim Oranı"
                              value={process.discount}
                              onChange={(e) => this.handleProcessChange(index, "discount", e.target.value)}
                              onWheel={this.handleNumberInputWheel}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`cost-${index}`} className="font-weight-bold small">
                              Maliyet (₺)
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={`cost-${index}`}
                              placeholder="0.00"
                              value={process.cost}
                              onChange={(e) => this.handleProcessChange(index, "cost", e.target.value)}
                              onWheel={this.handleNumberInputWheel}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`price-${index}`} className="font-weight-bold small">
                              Tutar (₺)
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={`price-${index}`}
                              placeholder="Tutar"
                              value={process.price}
                              onChange={(e) => this.handleProcessChange(index, "price", e.target.value)}
                              onWheel={this.handleNumberInputWheel}
                            />
                          </div>
                          <div className={isMobile ? 'col-lg mt-2 sd-line-action' : 'col-auto sd-line-action'}>
                            {index > 0 ? (
                              <button
                                type="button"
                                className="sd-remove-line"
                                onClick={() => this.handleRemoveProcess(index)}
                                title="Satırı Sil"
                              >
                                <i className="fa fa-trash"></i><span>Sil</span>
                              </button>
                            ) : <span className="sd-first-line-note">İlk kalem</span>}
                          </div>
                        </div>
                      ))}
                      <div className="sd-form-submit-row">
                        {processLoading ? (
                          <button className="sd-save-button" disabled>
                            <i className="fa fa-circle-o-notch fa-spin" /> Kaydediliyor...
                          </button>
                        ) : (
                          <button disabled={!userHasUpdateServiceProcess} className="sd-save-button" type="submit">
                            <i className="fa fa-check" /> Ürün ve hizmetleri kaydet
                          </button>
                        )}
                      </div>
                    </form>

                    {/* Tevkifat arayüzü geçici olarak gizlendi.
                        Modal state'i, hesaplamalar ve kayıt fonksiyonları korunuyor. */}

                  </div>
                </div>
              </div>
            </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isCustomerDetailModalOpen: mailInboxReducer.isCustomerDetailModalOpen,
  isVehicleDetailModalOpen: mailInboxReducer.isVehicleDetailModalOpen
});

export default subscriptionPermissionsControl(withPermissions(withRouter(connect(mapStateToProps, {
  openCustomerDetailModel,
  openVehicleDetailModel,
  closeCustomerDetailModel,
  closeVehicleDetailModel
})(ServiceDetail))));
